module.exports = __webpack_public_path__ + "static/media/settings.57ac1475.svg";